import { plainToClass } from "class-transformer";
import { ContactListingDto } from "./contacts.objects";
import { ContactDialog } from "./components/contact-dialog";
import { TableColumnVisibilityController, TableColumnGroup } from "../../../shared/scripts/table-column-visibility";
import { Unique } from "../../../shared/scripts/array-functions";
import { IFilter } from "../../../shared/scripts/filtering/filtering.entities";
import { InitializeFilterDropdown } from "../../../shared/scripts/filtering/filtering.utilities";
import { getData } from "../sites/scripts/site.utilities";
import { AuditHistoryDialog } from "../audit/scripts/audit-history.dialog";

export class ContactsPage implements IFilter {
    contacts: ContactListingDto[];
    contactDialog: ContactDialog;
    dataTable: any;
    filterDropdownIds: string[];
    isNonViewer: boolean;
    isAdmin: boolean;
    archiveContactId: number;
    token: string;

    constructor(allContactsJson: any, allSitesJson: any, allJobFunctions, isNonViewer: boolean, isAdmin: boolean) {
        $(() => {
            this.token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');
            this.contacts = plainToClass(ContactListingDto, <ContactListingDto[]>allContactsJson);
            this.contacts.forEach((contact: ContactListingDto) => { contact.initialize(); });
            this.filterDropdownIds = [
                '#site-dropdown', '#role-dropdown', '#study-dropdown'
            ];
            this.isNonViewer = isNonViewer === true;
            this.isAdmin = isAdmin === true;
            this.initializeArchiveModal();
            this.initializeFilters();
            this.initializeTable();
            const auditDialog = new AuditHistoryDialog();
            this.contactDialog = new ContactDialog(allSitesJson, allJobFunctions, auditDialog);
            this.contactDialog.successCallback = this.saveSuccess.bind(this);

        });
    }

    initializeFilters(): void {
        // Site filter
        let siteValues: string[] = [];
        this.contacts.forEach(c => siteValues.push(...c.SiteNames));
        siteValues.push("Unassigned");
        InitializeFilterDropdown('#site-dropdown', Unique(siteValues, true, ["None Selected"]), this);
        // Role filter
        //let roleValues: string[] = this.contacts
        //    .map(c => c.Role)
        //    .filter(role => role && role.trim().length > 0);
        let roleValues: string[] = [];
        this.contacts.forEach(c => roleValues.push(...c.Role));
        roleValues.push("Unassigned");
        InitializeFilterDropdown('#role-dropdown', Unique(roleValues, true, ["None Selected"]), this);
        // Study filter
        let studyValues: string[] = [];
        this.contacts.forEach(c => studyValues.push(...c.StudyNames));
        studyValues.push("Unassigned");
        InitializeFilterDropdown('#study-dropdown', Unique(studyValues, true, ["None Selected"]), this);
    }

    initializeTable(): void {
        const self = this;
        this.dataTable = $('#contacts-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[0, 'asc']], // Order by Contact Name
            columns: [
                //{
                //    data: null,
                //    title: '<input type="checkbox" />',
                //    className: "ctms-table-col-check",
                //    orderable: false,
                //    render: function () {
                //        return '<input type="checkbox" />';
                //    }
                //},
                { data: "ContactName", title: "Contact Name" },
                { data: "SiteNames", title: "Site Name(s)", render: (data) => Array.isArray(data) ? data.join(", ") : data },
                { data: "StudyNameAndRole", title: "Study", render: (data) => Array.isArray(data) ? data.slice().sort().join(", ") : data },
                //{ data: "StudyNames", title: "Study Name(s)", render: (data) => Array.isArray(data) ? data.slice().sort().join(", ") : data },
                //{ data: "Role", title: "Role" },
                { data: "Email", title: "Email" },
                { data: "PhoneNumber", title: "Phone Number" },
                {
                    data: null,
                    title: "",
                    className: "ctms-table-col-actions",
                    orderable: false,
                    render: function (data, type, row) {
                        let html = `
                            <button title="Edit"><i class="ctms-icon-pencil"></i></button>`;
                        if (self.isAdmin) {
                            html += `<button class="archive-contact-btn ml-2" data-id="${row.Id}" data-name="${row.ContactName}" title="Archive"><i class="ctms-icon-archive"></i></button>`;
                        }
                        return html;
                    }
                }
            ],
            data: this.contacts
        });

        $('#custom-dt-search').on('input', function () {
            $('#contacts-table').DataTable().search(String($(this).val() ?? '')).draw();
        });
        $('.ctms-icon-button[title="Clear Search"]').on('click', function () {
            $('#custom-dt-search').val('');
            $('#contacts-table').DataTable().search('').draw();
        });

        $(document).on('click', '#contacts-table .ctms-icon-pencil', async (evt) => {
            var row = $(evt.target).closest('tr');
            var data = $('#contacts-table').DataTable().row(row).data();
            if (!data || !data.Id) return;
            const contact = await getData(`/secure/ctms/contacts/contacts?handler=ContactDetails&id=${data.Id}`);
            if (this.isNonViewer) {
                this.contactDialog.populateModal(contact);
            }
            else {
                this.contactDialog.populateReadonlyModal(contact);
            }
            $('#newContactDialog').modal('show');
        });
        $(document).on('click', '#contacts-table .archive-contact-btn', (e) => {
            const $btn = $(e.currentTarget);

            this.archiveContactId = parseInt($btn.data('id'), 10);

            $('#archiveContactName').text($btn.data('name'));

            $('#archiveContactModal').modal('show');
        });
        $('#newContactButton').on('click', (evt) => {
            this.contactDialog.clearContactModal();
            $('#newContactDialog').modal('show');
        });
    }

    initializeArchiveModal(): void {
        $('#archiveContactModal').modal({
            backdrop: 'static',
            show: false,
        });

        $('#confirmArchiveContactBtn').on('click', () => {
            $('#confirmArchiveContactBtn').prop('disabled', true);
            $('#archiveContactSpinner').show();

            $.ajax({
                url: '/secure/ctms/contacts/contacts?handler=ArchiveContact',
                headers: { "RequestVerificationToken": this.token },
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ Id: this.archiveContactId }),
                success: (resp) => {
                    if (resp.success) {
                        const idToRemove = this.archiveContactId;

                        this.contacts = this.contacts.filter(
                            contact => contact.Id !== idToRemove
                        );

                        $('#contacts-table')
                            .DataTable()
                            .rows((idx, data: any) => data.Id === idToRemove)
                            .remove()
                            .draw();

                        $('#archiveContactModal').modal('hide');
                    } else {
                        alert(
                            'Error archiving contact: ' +
                            (resp.error ?? 'Unknown error.')
                        );
                    }
                },
                error: () => {
                    alert('Error archiving contact.');
                },
                complete: () => {
                    $('#confirmArchiveContactBtn').prop('disabled', false);
                    $('#archiveContactSpinner').hide();
                }
            });
        });
    }

    updateTable(matchingItems: ContactListingDto[]): void {
        this.dataTable.clear();
        this.dataTable.rows.add(matchingItems).draw();
    }

    triggerFilter(): void {
        const selectedSite = this.getSelectedDropdownValues('#site-dropdown');
        const selectedRole = this.getSelectedDropdownValues('#role-dropdown');
        const selectedStudy = this.getSelectedDropdownValues('#study-dropdown');

        const matchingContacts: ContactListingDto[] = [];

        this.contacts.forEach(item => {
            if (item.matchesFilter(
                selectedSite,
                selectedRole,
                selectedStudy
            )) {
                matchingContacts.push(item);
            }
        });

        this.updateTable(matchingContacts);
    }

    getSelectedDropdownValues(selectId: string): any {
        return $(selectId).val();
    }

    resetFilters(): void {
        this.filterDropdownIds.forEach((dropdownId: string) => {
            $(dropdownId).selectpicker('selectAll');
            $(dropdownId).selectpicker('refresh');
        });
        $('#custom-dt-search').val('');
        this.dataTable.search('').draw();
        this.updateTable(this.contacts);
    }

    saveSuccess(response: any) {

        if (response && response.success && response.contact) {
            const contact = plainToClass(ContactListingDto, <ContactListingDto>response.contact);
            contact.initialize();

            if (response.type === 'add') {
                this.contacts.push(contact);
            } else {
                // replace list item
                const idx = this.contacts.findIndex((c) => c.Id === contact.Id);
                this.contacts.splice(idx, 1, contact);
            }

            this.filterDropdownIds.forEach(id => {
                $(id).selectpicker('destroy');
                $(id).empty();
            });
            this.resetFilters();
            this.updateTable(this.contacts);
            this.initializeFilters();
        }
    }
}